<div class="row">
  <div class="col-md-6">
    <div>
      <fieldset style="border: 0;"
        [disabled]="!hasRole('vessels-off-hire-editor')">
        <form class="form-horizontal" #CrewChange="ngForm">
          <div class="card">
            <div class="card-body">
              <div class="form-group row">
                <div class>
                  <div class="form-group row">
                    <app-material-auto-complete
                      name="vessel"
                      id="vessel"
                      [formatter]="vesselFormatter"
                      [(ngModel)]="vessel"
                      [items]="vessels"
                      [placeholder]="'Vessel'"
                      [required]="true">
                    </app-material-auto-complete>
                  </div>
                  <div class="form-group row">
                    <mat-form-field>
                      <mat-label>Status</mat-label>
                      <mat-select
                        name="status"
                        id="status"
                        [(ngModel)]="status"
                        required>
                        <mat-option value="potential">Potential</mat-option>
                        <mat-option value="claimed">Claimed</mat-option>
                        <mat-option value="accepted">Accepted</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (offHires && offHires.length > 0) {
                    <div class="form-group row"
                      >
                      <app-material-auto-complete
                        name="related"
                        id="related"
                        [formatter]="offHireFormatter"
                        [(ngModel)]="relatedOffHire"
                        [placeholder]="'Related Off Hire'"
                        [items]="offHires">
                      </app-material-auto-complete>
                    </div>
                  }
                  <div class="form-group row">
                    <mat-form-field>
                      <mat-label for="type"
                      class="col-form-label col-md-4 ">Type</mat-label>
                      <mat-select
                        name="type"
                        id="type"
                        [(ngModel)]="offHireType"
                        required>
                        <mat-option value="dryDock">Dry Dock</mat-option>
                        <mat-option value="breakDown">Break Down</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <app-material-organisation-selector
                        id="fromPort"
                        class="pg-component"
                        [(ngModel)]="fromPort"
                        [organisationLanguage]="'en'"
                        name="fromPort"
                        [organisations]="ports"
                        [placeholder]="'From'"
                        [required]="true">
                      </app-material-organisation-selector>
                    </div>
                    <div class="col-md-6">
                      <app-material-date-range
                        id="date"
                        [singleDateSelector]="true"
                        [(dateRange)]="fromDate"
                        [timePicker]="true"
                        [localeDateFormat]="'YYYY-MM-DD HH:mm'">
                      </app-material-date-range>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-6">
                      <app-material-organisation-selector
                        id="toPort"
                        class="pg-component"
                        [(ngModel)]="toPort"
                        [organisationLanguage]="'en'"
                        name="toPort"
                        [organisations]="ports"
                        [placeholder]="'To'"
                        [required]="true">
                      </app-material-organisation-selector>
                    </div>
                    <div class="col-md-6">
                      <app-material-date-range
                        id="date"
                        [singleDateSelector]="true"
                        [(dateRange)]="toDate"
                        [timePicker]="true"
                        [localeDateFormat]="'YYYY-MM-DD HH:mm'">
                      </app-material-date-range>
                    </div>
                  </div>
                  @for (item of bunkers; track $index; let i = $index) {
                    <div class="form-group row">
                      <mat-form-field class="col-md-6">
                        <mat-label>Bunker</mat-label>
                        <mat-select
                          name="Product_{{i}}"
                          id="Product"
                          tabindex="4"
                          [(ngModel)]="bunkers[i].bunkerType"
                          required>
                          @for (product of productName; track $index) {
                            <mat-option
                              value="{{ product }}">
                              {{ product }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field class="col-md-6">
                        <input
                          matInput
                          type="number"
                          [(ngModel)]="bunkers[i].amount"
                          name="item_{{i}}"
                          required>
                        </mat-form-field>
                      </div>
                    }
                    <div class="form-group row">
                      <app-material-pg-input
                        label="Amount/USD"
                        type="number"
                        name="amount"
                        [(ngModel)]="amount"
                        [required]="true">
                      </app-material-pg-input>
                    </div>
                    <div class="form-group row">
                      <app-material-chunk-file-uploader
                        [accept]="'.pdf'"
                        name="document"
                        [ngModel]="doc"
                        (ngModelChange)="uploadDocument($event)">
                      </app-material-chunk-file-uploader>
                    </div>
                  </div>
                </div>
                <div class="btn-group pull-right mt-3">
                  <button
                    mat-raised-button
                    mat-stroked-button
                    type="submit"
                    class="me-1"
                    [disabled]="!CrewChange.form.valid || !fromDate || !toDate"
                    (click)="save()">
                    Save
                  </button>
                  <button
                    mat-raised-button
                    mat-stroked-button
                    class="me-1"
                    (click)="newBunker()">
                    Add Bunker
                  </button>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      </div>
    </div>
    @if (documentId) {
      <div class="col-md-6">
        <app-material-pdf-viewer [fileId]="documentId"></app-material-pdf-viewer>
      </div>
    }
  </div>